module.exports = __webpack_public_path__ + "static/media/Portfolio_small.e2f7ae0f.JPG";